// Clairessence Global JS

/* ─── Fade-in IntersectionObserver ─────────────────────────────── */
(function () {
    const THRESHOLD = 0.12;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    observer.unobserve(entry.target);
                }
            });
        },
        { threshold: THRESHOLD }
    );

    function observeAll() {
        document.querySelectorAll('.fade-in:not(.visible)').forEach((el) => {
            observer.observe(el);
        });
    }

    // Debounce de observeAll : évite un re-scan global en rafale
    // (le MutationObserver ajoute lui-même .visible → risque de boucle).
    let scanScheduled = false;
    function scheduleObserveAll() {
        if (scanScheduled) return;
        scanScheduled = true;
        window.requestAnimationFrame(() => {
            scanScheduled = false;
            observeAll();
        });
    }

    // Observer initial sur DOMContentLoaded
    document.addEventListener('DOMContentLoaded', observeAll);

    // Observer les mutations DOM (contenu injecté dynamiquement).
    // On n'observe plus les attributs (class) : seul l'ajout/retrait de
    // noeuds (childList) doit déclencher un nouveau scan, débounçé.
    const mutationObserver = new MutationObserver(() => {
        scheduleObserveAll();
    });

    document.addEventListener('DOMContentLoaded', () => {
        mutationObserver.observe(document.body, { childList: true, subtree: true });
    });
})();
